<template>
  <!-- 添加dom记得适应手机端 -->
  <div id="mapview" class="mapcontainer">
    <div class="infoview">
      <!-- <input id="btnStart" @click="startRotate" type="button" class="btn btn-primary" value="开始" />
      <input id="btnStop" @click="stopRotate" type="button" class="btn btn-primary" value="停止" /> -->
      <input id="btnStop" @click="flyToPile" type="button" class="btn btn-primary" value="flyTo" />
      <input id="btnStop" @click="toAllPiling" type="button" class="btn btn-primary" value="打桩回放" />
      <input id="btnStop" @click="toAllPilingThree" type="button" class="btn btn-primary" value="打桩桩径" />
      <input id="btnStop" @click="toPileZL" type="button" class="btn btn-primary" value="桩质量" />

      <div style="margin-top: 5px;">
        <!-- <div class="checkbox checkbox-primary checkbox-inline">
          <input id="chkTerrain" @change="chkTerrain" class="styled" type="checkbox" />
          <label for="chkTerrain"> 开启地形 </label>
        </div> -->
        <div class="checkbox checkbox-primary checkbox-inline">
          <input id="chkTerrainClip" @change="chkTerrainClip" class="styled" type="checkbox" checked />
          <label for="chkTerrainClip">显示坑</label>
        </div>
        <!-- <div class="checkbox checkbox-primary checkbox-inline">
          <input id="chkTerrainPile" @change="chkTerrainPile" class="styled" type="checkbox" checked />
          <label for="chkTerrainPile">显示桩</label>
        </div> -->
        <!-- <div v-if="!ispc" class="checkbox checkbox-primary checkbox-inline">
          <input id="fullScreen" @change="chkFullScreen" class="styled" type="checkbox" />
          <label for="fullScreen">全屏</label>
        </div> -->
      </div>
      <div>
        <!-- <div class="checkbox checkbox-primary checkbox-inline">
          <input id="chkTerrainOtherPile" @change="chkTerrainOtherPile" class="styled" type="checkbox" />
          <label for="chkTerrainOtherPile">未施工桩</label>
        </div>
        <div class="checkbox checkbox-primary checkbox-inline">
          <input id="chkTestTerrain" @change="chkTestTerrain" class="styled" type="checkbox" />
          <label for="chkTestTerrain">深度测试</label>
        </div> -->
      </div>
      <div>
        <div class="checkbox checkbox-primary checkbox-inline">
          <input id="chkUnderground" @change="chkUnderground" class="styled" type="checkbox" />
          <label for="chkUnderground">开启地下模式</label>
        </div>
      </div>
      <div v-if="underground" class="block">
        <span class="demonstration">地表透明度</span>
        <el-slider v-model="undergroundValue" @input="changeUndergroundValue" :min="0" :max="1" :step="0.1" :show-tooltip="false"></el-slider>
      </div>
    </div>
    <div class="infoview2" v-show="showInfo2">
      桩编号: {{selectedPile.c_code}}
    </div>
    <Map :url="configUrl" @onload="onMapload" />
    <div class="left-charts" v-bind:class="{ phoneCharts: !ispc, verticalScreen1: !isHorizontalScreen }" v-show="showLeftChart">
      <LineCharts @onClose="showLeftChart1=false" v-bind:class="{ pcCharts1: ispc }" v-show="showLeftChart1" name="Current" :option="chartOption[0]" :chartData="[chartData.zdhr.Current, chartData.bjzc.Current]"></LineCharts>
      <LineCharts @onClose="showLeftChart2=false" v-bind:class="{ pcCharts2: ispc }" v-show="showLeftChart2" name="Depth" :option="chartOption[1]" :chartData="[chartData.zdhr.Depth, chartData.bjzc.Depth]"></LineCharts>
    </div>
    <div class="right-charts" v-bind:class="{ phoneCharts: !ispc, rightPhoneCharts: !ispc, verticalScreen2: !isHorizontalScreen }" v-show="showRightChart">
      <LineCharts @onClose="showRightChart1=false" v-bind:class="{ pcCharts3: ispc }" v-show="showRightChart1" name="fillingsSum" :option="chartOption[2]" :chartData="[chartData.zdhr.fillingsSum, chartData.bjzc.fillingsSum]"></LineCharts>
      <LineCharts @onClose="showRightChart2=false" v-bind:class="{ pcCharts4: ispc }" v-show="showRightChart2" name="waterFlow" :option="chartOption[3]" :chartData="[chartData.zdhr.waterFlow, chartData.bjzc.waterFlow]"></LineCharts>
      <LineCharts @onClose="showRightChart3=false" v-bind:class="{ pcCharts5: ispc }" v-show="showRightChart3" name="waterPressure" :option="chartOption[4]" :chartData="[chartData.zdhr.waterPressure, chartData.bjzc.waterPressure]"></LineCharts>
    </div>
    <div v-if="showPiling" v-bind:class="{ pilingDiv: ispc, phonePilingDiv: !ispc }">
      <Piling :pileCode="pilingPileCode" :showIcon="true" :infoview2Style="pilingStyle" @onClose="showPiling=false"></Piling>
    </div>
  </div>
</template>

<script>
import Map from '../components/mars3d/Map.vue'
import LineCharts from '../components/charts/LineCharts.vue'
import Piling from '../components/animation/piling.vue'
import { isPC } from '../../static/util/pqtutil'
let ispc = true
let isHorizontalScreen = true
export default {
  components: {
    Map,
    LineCharts,
    Piling
  },
  data() {
    const basePathUrl = window.basePathUrl || ''
    const scale = 1
    return {
      configUrl: basePathUrl + 'static/mapconfig/config.json', // 配置文件
      baseDataUrl: basePathUrl + 'static/mapconfig/baseData.json', // 所有桩数据
      baseDataUrl2: basePathUrl + 'static/mapconfig/baseData2.json', // 有数据桩数据 
      baseDataUrl3: basePathUrl + 'static/mapconfig/baseData3.json', // 无数据桩数据
      pileJsonUrl: basePathUrl + 'static/mapconfig/pileJson.json', // 图层生成json数据
      drawer: false,
      drawerUrl: '',
      // 客户端环境
      ispc: ispc,
      isHorizontalScreen: isHorizontalScreen,
      // 地图对象
      map: {},
      // 桩在地图上缩放的比例
      pileScale: scale,
      // 地形开挖对象
      terrainClip: {},
      // 开挖矩形区域参数
      area: [
        [102.202828,29.739804,1085.9],
        [102.202718,29.7359,1085.6],
        [102.20006,29.736179,1085.2],
        [102.199636,29.739558,1085.9],
      ],
      // 开挖深度 * 缩放比例
      clipHeight: 36 * scale,
      // 开挖记录对象数组
      areaItems: [],
      // 桩图层
      pileGraphicLayer: {},
      modelCombine: {},
      // 桩数据
      piles: [],
      showInfo2: false,
      selectedPile: {},
      // 未施工桩图层
      otherPileGraphicLayer: {},
      // 未施工桩数据
      otherPiles: [],
      // 曲线数据
      chartData: {zdhr:{},bjzc:{}},
      // 曲线option
      chartOption: [{title:'电流'}, {title:'深度'}, {title:'填料量'}, {title:'瞬时水量'}, {title:'瞬时水压'}],
      // 曲线是否显示
      showLeftChart: false,
      showRightChart: false,
      showLeftChart1: false,
      showLeftChart2: false,
      showRightChart1: false,
      showRightChart2: false,
      showRightChart3: false,
      // 单桩3d打桩动画
      pilingPileCode: '',
      showPiling: false,
      pilingStyle: {
        top: '105%',
        left: '50%'
      },
      // 地下模式类
      underground: '',
      // 地面透明度
      undergroundValue: 0.5,

      // askurl: "http://mcc.wedam.com.cn/zhenchongearth",
      askurl: "",
    }
  },
  beforeCreate() {
    ispc = isPC(navigator.userAgent)
    if (!ispc) {
      const { clientHeight, clientWidth } = document.body
      isHorizontalScreen = clientHeight < clientWidth
      window.onresize = () => {
        isHorizontalScreen = clientHeight < clientWidth
      }
    }
  },
  methods: {
    // 地图构造完成回调
    onMapload(map) {
      console.log("地图构造完成")
      this.map = map
      this.startRotate()
      this.initTerrainClip()
      this.initPileGraphicLayer()
      this.initOtherPileGraphicLayer()
    },
    // 初始化桩图层
    initPileGraphicLayer() {
      const { map, mars3d, Cesium, baseDataUrl2, pileJsonUrl } = this
      // 先取toJson生成的json文件,没有的话取原始数据(只能是颜色的,带材质的不行,不知道为啥)
      // mars3d.Resource.fetchJson({ url: pileJsonUrl }).then(res => {
      //   if (res.type === 'graphic') {
      //     this.pileGraphicLayer = new mars3d.layer.GraphicLayer({ data: res.data })
      //     this.pileGraphicLayer.show = false
      //   } else {
          this.pileGraphicLayer = new mars3d.layer.GraphicLayer()
          mars3d.Resource.fetchJson({ url: baseDataUrl2 }).then(data => {
            // this.piles = data.data.positionList
            this.piles = data.data
            let start = new Date().getTime()
            this.createGltfPiles(this.piles, this.pileGraphicLayer)
            // this.createPiles(this.piles)
            console.log("成功创建桩，用时" + (new Date().getTime() - start) / 1000 + "秒")
          })
        // }
        map.addLayer(this.pileGraphicLayer)
      // })
    },
    // 用gltf格式文件生成大量桩
    createGltfPiles(piles, pileGraphicLayer, url = './static/mapconfig/gltf/cylinder3.gltf') {
      const { map, mars3d, XYtoLinLat } = this
      const arrData = piles.map(pile => {
        const { lin, lat } = XYtoLinLat(pile.x, pile.y)
        return {
          position: new mars3d.LatLngPoint(lin, lat, 1066.7),
          style: {
            heading: 270,
            scale: 20,
            },
          attr: pile
          }
      })
      const modelCombine = new mars3d.graphic.ModelCombine({
        url: url,
        instances: arrData,
      })
      pileGraphicLayer.addGraphic(modelCombine)
      // this.addLabel(piles)
      // this.bindMenu(pileGraphicLayer)
      this.bindMenu(modelCombine)
    },
    addLabel(piles) {
      const { map, mars3d, Cesium, XYtoLinLat } = this
      const graphicLayer = new mars3d.layer.DivLayer()
      map.addLayer(graphicLayer)
      piles.forEach(pile => {
        const { lin, lat } = XYtoLinLat(pile.x, pile.y)
        var graphic = new mars3d.graphic.CanvasBillboard({
          position: new mars3d.LatLngPoint(lin, lat, 1200),
          style: {
            text: 18,
            scale: 0.5,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            scaleByDistance: new Cesium.NearFarScalar(800, 0.4, 1200, 0.2),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 10000),
          },
        })
        graphic.text = pile.c_code
        graphicLayer.addGraphic(graphic)
      })
    },
    // 生成大量桩
    createPiles(piles) {
      const { mars3d, Cesium, pileGraphicLayer } = this
      // const material = mars3d.MaterialUtil.createMaterial(mars3d.MaterialType.Image , {
      //   image: './static/mapconfig/img/excavate_kuangqu.jpg'
      // })
      pileGraphicLayer.addGraphic(piles.map(pile => this.createPile(pile)))
      this.bindMenu(pileGraphicLayer)
      // 生成json文件,保存到pileJson.json中,之后再打开可以直接用
      // let pileJson = pileGraphicLayer.toJSON()
      // console.log(pileJson)
    },
    // 桩绑定事件
    bindMenu(modelCombine) {
      const { map, mars3d } = this
      // 绑定鼠标右键菜单
      modelCombine.bindContextMenu([
        // {
        //   text: '删除桩',
        //   callback: e => {
        //     let graphic = e.graphic
        //     if (graphic) {
        //       pileGraphicLayer.removeGraphic(graphic)
        //     }
        //   }
        // },
        {
          text: '桩信息',
          callback: e => {
            let attr = e.graphic.attr
            // this.$confirm('深度: ' + attr.c_dept + ', 桩径: ' + attr.c_diameter + 
            //   ', \n第三到四层分界: ' + attr.c_three_four + ', 第四到五层分界: ' + attr.c_four_five, attr.c_code, {
            //   confirmButtonText: '确定',
            //   showCancelButton: false,
            //   center: true
            // })
            map.openPopup(e.position, '桩号: ' + attr.c_code + '<br/>' + '深度: ' + attr.c_dept + '<br/>桩径: ' + 1.3 + 
              '<br/>第三到四层分界: ' + attr.c_three_four + '<br/>第四到五层分界: ' + attr.c_four_five)
          }
        },
        {
          text: '显示曲线',
          callback: e => {
            let code = e.graphic.attr.c_code
            let url = 'http://edam.tscon.cn:7777/zhenchongjava/lkApi/getSinglePileRealData?pileCode=' + code
            mars3d.Resource.fetchJson({url}).then(
              response => {
                if (response.code === 200) {
                  this.showLeftChart = true
                  this.showRightChart = true
                  this.showLeftChart1 = true
                  this.showLeftChart2 = true
                  this.showRightChart1 = true
                  this.showRightChart2 = true
                  this.showRightChart3 = true
                  this.chartData = response.data
                }
              }
            )
          }
        },
        // {
        //   text: '详细信息',
        //   callback: e => {
        //     let code = e.graphic.attr.c_code
        //     let a = document.createElement('a')
        //     a.target = '_blank'
        //     a.href = 'http://mcc.wedam.com.cn/zhenchong/index.html#/pages/main/singlePile/singlePile?code=' + code
        //     a.click()
        //   }
        // },
        // {
        //   text: '打桩进度',
        //   callback: e => {
        //     let code = e.graphic.attr.c_code
        //     this.drawerUrl = 'http://mcc.wedam.com.cn/zhenchong/static/html/dailyPileCompelete.html'
        //     this.drawer = true
        //   }
        // },
        {
          text: '单桩三维',
          callback: e => {
            let code = e.graphic.attr.c_code
            this.pilingPileCode = code
            this.showPiling = true
          }
        }
      ])
      if (this.ispc) {
        // 鼠标移入事件
        modelCombine.on(mars3d.EventType.mouseOver, this.mouseOver, this)
        // 鼠标移出事件
        modelCombine.on(mars3d.EventType.mouseOut, this.mouseOut, this)
      }
      // 手机端绑定click事件
      if (!this.ispc) {
        modelCombine.on(mars3d.EventType.click, function(event) {
          this.openContextMenu(event.cartesian)
        }, modelCombine)
      }
      // 打开时高亮
      // modelCombine.on(mars3d.EventType.rightClick, (event) => {
      //   console.log(event)
      //   map.openHighlight(event.graphic, {
      //     silhouette: true,
      //     silhouetteColor: '#ECF22A',
      //     silhouetteSize: 4
      //   }, event)
      // }, modelCombine)
    },
    // 鼠标移入回调
    mouseOver(event) {
      this.selectedPile = event.graphic.options.attr
      this.showInfo2 = true
    },
    // 鼠标移出回调
    mouseOut(event) {
      this.showInfo2 = false
    },
    // 手机端click监听器回调函数
    phoneClick(event) {
      console.log(this)
      this.openContextMenu(event.cartesian)
    },
    // 显示/隐藏桩
    chkTerrainPile(event) {
      const { pileGraphicLayer } = this
      pileGraphicLayer.show = event.target.checked
    },
    // 生成大量没有数据的桩
    createOtherPiles(piles, isCreated) {
      const { mars3d, otherPileGraphicLayer } = this
      if (!isCreated) {
        // const material = mars3d.MaterialUtil.createMaterial(mars3d.MaterialType.Image2, {
        //   image: './static/mapconfig/img/pile_material.png'
        // })
        otherPileGraphicLayer.addGraphic(piles.map(pile => this.createPile(pile)))
      }
      // 绑定鼠标右键菜单
      otherPileGraphicLayer.bindContextMenu([
        // {
        //   text: '删除桩',
        //   callback: e => {
        //     let graphic = e.graphic
        //     if (graphic) {
        //       otherPileGraphicLayer.removeGraphic(graphic)
        //     }
        //   }
        // },
        {
          text: '桩信息',
          callback: e => {
            let attr = e.graphic.attr
            this.$alert('深度: ' + (attr.c_dept?attr.c_dept:'暂无数据') + ', 桩径: ' + 1.3 + 
              ', 第三到四层分界: ' + (attr.c_three_four?attr.c_three_four:'暂无数据') + ', 第四到五层分界: ' + (attr.c_four_five?attr.c_four_five:'暂无数据'), attr.c_code, {
              confirmButtonText: '确定'
            })
          }
        },
        // {
        //   text: '详细信息',
        //   callback: e => {
        //     let code = e.graphic.attr.c_code
        //     let a = document.createElement('a')
        //     a.target = '_blank'
        //     a.href = 'http://mcc.wedam.com.cn/zhenchong/index.html#/pages/main/singlePile/singlePile?code=' + code
        //     a.click()
        //   }
        // },
        // {
        //   text: '打桩进度',
        //   callback: e => {
        //     let code = e.graphic.attr.c_code
        //     this.drawerUrl = 'http://mcc.wedam.com.cn/zhenchong/static/html/dailyPileCompelete.html'
        //     this.drawer = true
        //   }
        // }
      ])
      // 生成json文件,保存到pileJson.json中,之后再打开可以直接用
      // let pileJson = otherPileGraphicLayer.toJSON()
      // console.log(pileJson)
    },
    // 显示/隐藏其它桩
    chkTerrainOtherPile(event) {
      const { otherPileGraphicLayer } = this
      if (event.target.checked && this.otherPiles.length === 0) {
        // 首次点击
        this.$message('初次加载，请耐心等待')
        this.initOtherPileGraphicLayer()
      } else if (this.otherPiles.length > 0) {
        otherPileGraphicLayer.show = event.target.checked
      }

    },
    // 初始化没有数据的桩的图层
    initOtherPileGraphicLayer() {
      const { map, mars3d, Cesium, baseDataUrl3, pileJsonUrl } = this
      // 先取toJson生成的json文件,没有的话取原始数据(只能是颜色的,带材质的不行,不知道为啥)
      // mars3d.Resource.fetchJson({ url: pileJsonUrl }).then(res => {
      //   if (res.type === 'graphic') {
      //     this.otherPiles = res.data
      //     this.otherPileGraphicLayer = new mars3d.layer.GraphicLayer({ data: res.data })
      //     this.createOtherPiles(this.otherPiles, true)
      //   } else {
          this.otherPileGraphicLayer = new mars3d.layer.GraphicLayer()
          mars3d.Resource.fetchJson({ url: baseDataUrl3 }).then(data => {
            let start = new Date().getTime()
            this.otherPiles = data.data
            // this.createOtherPiles(this.otherPiles, false)
            this.createGltfPiles(this.otherPiles, this.otherPileGraphicLayer, './static/mapconfig/gltf/cylinder4.gltf')
            console.log("成功创建桩，用时" + (new Date().getTime() - start) / 1000 + "秒")
          })
        // }
        map.addLayer(this.otherPileGraphicLayer)
      // })
    },
    // 创建一个桩（圆柱）
    createPile(pile, material) {
      const { c_id, c_code, c_dept, c_diameter, x, y, c_three_four, c_four_five } = pile
      const { mars3d, Cesium, pileScale } = this
      const { lin, lat } = this.XYtoLinLat(x, y)
      // material = mars3d.MaterialUtil.createMaterial(mars3d.MaterialType.Text , {
      //   text: c_code,
      //   font_size: 14,
      //   font_weight: 'bold',
      //   backgroundColor: Cesium.Color.HOTPINK
      // })
      let position = new mars3d.LatLngPoint(lin, lat, 1164.7)
      let length = c_dept || 30
      let label = {
        text: c_code,
        scale: 0.7,
        font_size: 14,
        color: '#000000',
        visibleDepth: false,
        scaleByDistance: true,
        distanceDisplayCondition: true,
        distanceDisplayCondition_far: 300,
        addHeight: length * pileScale * 0.5 + 5
      }
      let style = {
        topRadius: c_diameter * pileScale,
        bottomRadius: c_diameter * pileScale,
        length: length * pileScale,
        slices: 20,
        opacity: 1,
        color: '#C14242',
        // material: material,
        label: label
      }
      let attr = { c_code, c_dept, c_diameter, c_three_four, c_four_five  }
      let options = { position, style, attr }
      return new mars3d.graphic.CylinderPrimitive(options)
    },
    // 转换x, y到经纬度
XYtoLinLat(x, y) {
      const { area } = this
      // 直接根据区域范围大小，按比例缩放102.214969,29.753441,1201.6
      // 102.202828,29.739804,1190.9 , 笛卡尔：-1171779.2,5418399,3145953.3
      // 102.202718,29.7359,1185.6 , 笛卡尔：-1171813.3,5418606.6,3145574.8
      // 102.199636,29.739558,1258.9 , 笛卡尔：-1171492.7,5418535.2,3145963.3
      // 102.20006,29.736179,1198.2 , 笛卡尔：-1171561,5418656.7,3145607.9
      let lin, lat
      lin = 102.199636 + (102.202828 - 102.199636) * (x - 519365.932)  / (519654.560 - 519365.932)
      lat = 29.7359 + (29.739804 - 29.7359) * (y - 3291144.664) / (3291370.186 - 3291144.664)
      // 翻转180度102.214961,29.754559
      lin = 102.201232 * 2 - lin 
      lat = 29.737852 * 2 - lat
      return {lin, lat}
    },
    // 开启/关闭地形显示
    chkTerrain(event) {
      const { map, mars3d } = this
      if (event.target.checked) {
        map.terrainProvider = mars3d.LayerUtil.createTerrainProvider({
          type: "arcgis",
          url: "https://elevation3d.arcgis.com/arcgis/rest/services/WorldElevation3D/Terrain3D/ImageServer",
        })
      }
      map.hasTerrain = event.target.checked
    },
    // 初始化terrainClip对象
    initTerrainClip() {
      const { map, mars3d, clipHeight } = this
      map.setSceneOptions({
        center: { lat: 29.754631, lng: 102.216058, alt: 1205, heading: 89, pitch: -90 },
        highDynamicRange: true
      })
      let image = "./static/mapconfig/img/excavate_kuangqu.jpg"
      if (!ispc) {
        image = "./static/mapconfig/img/excavate_side_min.jpg"
      }
      this.terrainClip = new mars3d.thing.TerrainClip({
        diffHeight: clipHeight, //井的深度
        image: image,
        imageBottom: "./static/mapconfig/img/excavate_bottom_min.jpg",
        splitNum: 80, //井边界插值数
      })
      map.addThing(this.terrainClip)
      map.setSceneOptions({
        center: { lat: 23.26, lng: 110, alt: 21511287, heading: 0, pitch: -90 },
        highDynamicRange: false
      })
    },
    // 显示/隐藏坑区域
    chkTerrainClip(event) {
      const { areaItems, terrainClip } = this
      if (event.target.checked) {
        if (this.areaItems.length === 0) {
          this.drawExtentClip()
        } else {
          for (let i = 0; i < areaItems.length; i++) {
            terrainClip.showArea(areaItems[i].id)
          }
        }
      } else {
        for (let i = 0; i < areaItems.length; i++) {
          terrainClip.hideArea(areaItems[i].id)
        }
      }
    },
    // 坑区域深度测试
    chkTestTerrain(event) {
      const { map } = this
      map.scene.globe.depthTestAgainstTerrain = event.target.checked
    },
    // 手机端全屏显示
    // chkFullScreen(event) {
    //   if (event.target.checked) {
    //     this.mars3d.DomUtil.enterFullscreen(document.getElementById('mapview'))
    //   } else {
    //     this.mars3d.DomUtil.exitFullscreen()
    //   }
    // },
    // 添加坑区域
    drawExtentClip(area) {
      const { terrainClip } = this
      let a = area || this.area
      let areaItem = terrainClip.addArea(a)
      // 记录保存起来，方便后续其它操作
      this.areaItems.push(areaItem)

    },
    // 跳转到桩
    flyToPile() {
      const { map } = this
      this.stopRotate()


      map.setCameraView({
        lat: 29.727881,
        lng: 102.201744,
        alt: 2689,
        heading: 4,
        pitch: -61,
      });


      let options = {
        duration: 5,
        // 视角旋转角度
        pitch: -90,
        // 方向角度值
        heading: 89
      }
      map.flyToExtent(null, options)
      if (this.areaItems.length === 0) {
        // 添加一个坑区域
        this.drawExtentClip()
      }
      this.setTiles3DLayer()
      console.log("成功跳转到桩")
    },
    setTiles3DLayer() {
      const { mars3d, map } = this
      let tiles3dLayer = new mars3d.layer.TilesetLayer({
        type: "3dtiles",
        name: "航拍",
        //url: "http://mcc.wedam.com.cn/zhenchongearth/static/mapconfig/aa/tileset.json",
        // url: "/static/place/tileset.json",mapconfig\suidao
        url: this.askurl + "/static/place/tileset.json",
        scale: 180,
        position: { lat: 29.683268, lng: 102.192033, alt: 1200 },
        // maximumScreenSpaceError: 100,
        maximumMemoryUsage: 8096,
        dynamicScreenSpaceError: true,
        cullWithChildrenBounds: false,
        skipLevelOfDetail: true,
        preferLeaves: true,
        rotation: { z: -75 },
        // highlight: {
        //   type: mars3d.EventType.click, //默认为鼠标移入高亮，也可以指定click单击高亮
        //   color: "#00FF00",
        // },
        // popup: "all",
        // show: true,
        //center: { lat: 28.439577, lng: 102.2149, alt: 229, heading: 1000, pitch: -29 },
        flyTo: true,
      });
      map.addLayer(tiles3dLayer);

    },
    // 地球旋转
    startRotate() {
      const { map, mars3d } = this
      // 距离地面过近时，先回到初始状态
      if (map.getCameraDistance() < 1000000) {
        map.flyHome({duration: 3})
      }
      this.stopRotate()

      this.previousTime = map.clock.currentTime.secondsOfDay
      map.on(mars3d.EventType.clockTick, this.map_onClockTick)
    },
    stopRotate() {
      const { map, mars3d } = this
      map.off(mars3d.EventType.clockTick, this.map_onClockTick)
    },
    map_onClockTick(clock) {
      const { map } = this
      let spinRate = 150
      let currentTime = map.clock.currentTime.secondsOfDay
      let delta = (currentTime - this.previousTime) / 1000
      this.previousTime = currentTime
      map.scene.camera.rotateRight(-spinRate * delta)
    },
    addUnderground() {
      const { map, mars3d, undergroundValue } = this
      this.underground = new mars3d.thing.Underground({
        alpha: undergroundValue
      })
      map.addThing(this.underground)
    },
    chkUnderground(event) {
      if (this.underground) {
        this.underground.enabled = event.target.checked
      } else {
        this.addUnderground()
      }
    },
    changeUndergroundValue(val) {
      this.underground.alpha = val
    },
    toAllPiling() {
      let newpage = this.$router.resolve({ 
        name: 'allPiling'
      })
      window.open(newpage.href, '_blank');
    },

toPileZL(){
      let newpage = this.$router.resolve({ 
        name: 'allPilingZL'
      })
      window.open(newpage.href, '_blank');
},

    toAllPilingThree() {
      let newpage = this.$router.resolve({ 
        name: 'allPilingthree'
      })
      window.open(newpage.href, '_blank');
    }
  }
}
</script>

<style >
.mapcontainer {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.infoview {
  position: absolute;
  top: 0.6rem;
  left: 0.6rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.2rem;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0.2rem 0.9rem rgb(128 128 128 / 50%);
  z-index: 19870101;
}
.infoview2 {
  position: absolute;
  top: 0.6rem;
  left: 19.3rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.2rem;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0.2rem 0.9rem rgb(128 128 128 / 50%);
  z-index: 19870101;
}
.btn {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  margin-bottom: 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  outline: none;
}
.btn-primary {
  color: #fff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
}
.checkbox {
  padding-left: 0.3rem;
}
.checkbox-inline {
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  vertical-align: middle;
  cursor: pointer;
}
input[type="checkbox"] {
  width: 0.8rem;
  height: 0.8rem;
}
.checkbox label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-bottom: 0.3rem;
}
.right-charts {
  z-index: 800;
  position: absolute;
  right: 22rem;
  top: 10px;
  font-size: 0.9rem;
  border: none;
  color: #ffffff;
  background: none;
}
.left-charts {
  z-index: 800;
  position: absolute;
  left: 0px;
  top: 10rem;
  font-size: 0.8rem;
  border: none;
  color: #ffffff;
  background: none;
}
.phoneCharts {
  height: 13rem;
  overflow: auto;
}
.rightPhoneCharts {
  right: 3rem !important;
}
.pcCharts1 {
  position: absolute !important;
}
.pcCharts2 {
  position: absolute !important;
  top: 10.5rem;
}
.pcCharts3 {
  position: absolute !important;
}
.pcCharts4 {
  position: absolute !important;
  top: 10.5rem;
}
.pcCharts5 {
  position: absolute !important;
  top: 21rem;
}
.pilingDiv {
  position: absolute !important;
  width: 35%;
  top: 0.6rem;
  right: 0.6rem;
}
.phonePilingDiv {
  position: absolute !important;
  width: 90%;
  left: 0.6rem;
  top: 10rem;
}
.verticalScreen1 {
  top: 12rem !important;
}
.verticalScreen2 {
  top: 26rem !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Earth3D.vue